// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"a3d99076","43":"cf119a30","180":"41aaa874","181":"aec8d665","346":"79dabe0a","682":"0bacecfb"}[chunkId] + ".chunk.js";
};